var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PersonalCreate',{attrs:{"createPath":_vm.createPath,"editPath":_vm.editPath,"cuerpo-tecnico":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }